<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2 cursor-pointer" data-toggle="collapse" data-target="#brands-filter-1">
      {{ $t('filter.brand.title') }}
      <i class="bi bi-arrow-down-circle"></i>
    </h6>

    <div id="brands-filter-1" class="p-2 collapse">
      <div class="form-group form-check" v-for="brand in brandsObject" :key="brand.id">
        <input v-model="selectedBrands" @change="emitData" :value="brand[brandColumn]" name="filter_brands"
               type="checkbox"
               class="form-check-input" :id="`brand_filter_${brand.id}`">
        <label class="form-check-label mr-3" :for="`brand_filter_${brand.id}`">{{ brand.name }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterBrand1",
  props: {
    productBrands: {
      default: null
    },
    brandColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    brandsObject: {
      default: []
    },
  },
  data() {
    return {
      selectedBrands: [],
    }
  },
  async mounted() {
    if (this.productBrands != null) {
      this.selectedBrands = this.productBrands
    }
  },
  methods: {
    getBrandIds() {
      let ids = [];
      this.brandsObject.forEach(item => {
        if (this.selectedBrands.indexOf(item.id) > -1) {
          ids.push(item.id)
        }
      })
      return ids.length > 0 ? ids : null
    },
    getBrandSlugs() {
      let slugs = [];
      this.brandsObject.forEach(item => {
        if (this.selectedBrands.indexOf(item.slug) > -1) {
          slugs.push(item.slug)
        }
      })
      return slugs.length > 0 ? slugs : null
    },
    filterOutput() {
      if (this.brandColumn === 'id') {
        return this.getBrandIds();
      }
      if (this.brandColumn === 'slug') {
        return this.getBrandSlugs();
      }
    },
    emitData() {
      // todo make whole brands object return every thing and then before pass it to wrapper we customize it.
      this.$emit('brands', this.filterOutput())
    }
  },
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}
.cursor-pointer{
  cursor: pointer;

}

</style>